import { PageLoader } from 'components/root/page-loader';
import React, { Suspense } from 'react';
import { useExternalLogin } from 'hooks/use-external-login.hook';
import { AppContent } from './app-content';
import { useRefreshToken } from 'hooks/use-refresh-token.hook';
import { useVisitActivityStream } from 'hooks/use-visit-activity-stream';

export const App: React.FC = (): JSX.Element => {
  useRefreshToken();
  // App-wide, single SSE connection to search-service. A bare hook alongside the other two — not a
  // component — so a long-lived connection never sits inside the render tree's `<Suspense>` boundary,
  // where a route transition could tear it down and reconnect it.
  useVisitActivityStream();
  const shouldWaitForLogin = useExternalLogin();

  if (shouldWaitForLogin) {
    return <PageLoader />;
  }

  return (
    <Suspense fallback={<PageLoader />}>
      <AppContent />
    </Suspense>
  );
};
